import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mode: "dark",
    userId: '668f0265cc99d67a22f8ed3c',
};

export const globalSlice = createSlice({
    name: "global",
    initialState, 
    reducers: {
        setMode: (state) => {
            state.mode = state.mode === 'light' ? "dark" : 'light';
        }
    }
});

export const {setMode} = globalSlice.actions;
export default globalSlice.reducer;
